import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { 
  FaPhone, 
  FaMoneyBillWave,
  FaExchangeAlt,
  FaCamera,
  FaBuilding,
  FaMapMarkerAlt,
  FaMusic,
  FaHistory,
  FaTruck
} from 'react-icons/fa';
import { LuPiano } from "react-icons/lu";
import SeoHead from "../../components/Menu/components/SeoHead";
import '../../assets/css/comprapianos.css';

// Imagens de exemplo para a galeria (substitua pelas suas)
const galleryImages = [
{ id: 1, src: '/img/comprando/1.jpg', alt: '', },
{ id: 2, src: '/img/comprando/2.jpg', alt: '', },
{ id: 3, src: '/img/comprando/3.jpg', alt: '', },
{ id: 4, src: '/img/comprando/4.jpg', alt: '', },
{ id: 5, src: '/img/comprando/5.jpg', alt: '', },
{ id: 6, src: '/img/comprando/6.jpg', alt: '', },

];

const compraPianosSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "serviceType": "Compra de Pianos Usados",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Waldir Pianos",
    "image": "https://pianoswaldir.com.br/images/logo.jpg", 
    "url": "https://pianoswaldir.com.br",
    "telephone": "+55-11-2256-5987", 
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Waldemar Martins, 695",
      "addressLocality": "São Paulo",
      "addressRegion": "SP",
      "postalCode": "02535-000",
      "addressCountry": "BR"
    }
  },
  "name": "Compramos Pianos Usados | Waldir Pianos",
  "description": "Compramos pianos usados que necessitam de reforma, com pagamento à vista e retirada gratuita. Aceitamos seu piano como parte do pagamento na compra de um de nossos instrumentos restaurados. Oferecemos avaliação por fotos.",
  "areaServed": {
    "@type": "AdministrativeArea",
    "name": "São Paulo" 
  },
  "url": "https://pianoswaldir.com.br/compra-de-pianos",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://pianoswaldir.com.br/compra-de-pianos"
  },
  "image": "https://pianoswaldir.com.br/img/comprando/1.jpg"
};

const CompraDePianos = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // Rotação automática da galeria
  useEffect(() => {
    const interval = setInterval(() => {
      if (!isHovered) {
        setCurrentImageIndex((prevIndex) => 
          (prevIndex + 1) % galleryImages.length
        );
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [isHovered]);

  const currentImage = galleryImages[currentImageIndex];

  return (
    <div className="compra-pianos-container">
      <SeoHead
  title="Compramos Pianos Usados | Avaliação e Pagamento à Vista | Waldir Pianos"
  description="Venda seu piano usado para a Waldir Pianos! Compramos pianos para reforma, com pagamento à vista e retirada gratuita. Aceitamos permuta. Envie fotos para avaliação."
  keywords="comprar piano usado, venda de pianos, avaliação piano, piano à vista, retirada piano, permuta piano, Waldir Pianos"
  image="/img/comprando/1.jpg" 
  url="https://pianoswaldir.com.br/compra-de-pianos"
  canonicalUrl="https://pianoswaldir.com.br/compra-de-pianos"
  schemaMarkup={compraPianosSchema}
/>
      {/* Cabeçalho Clássico */}
      <motion.header 
        className="compra-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className="header-content">
          <motion.h1 
            className="main-title"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <LuPiano className="title-icon" />
            Compra de Pianos
            <span className="title-decoration"></span>
          </motion.h1>
          
          <motion.p 
            className="header-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            Transformamos histórias em novas melodias
          </motion.p>
        </div>
      </motion.header>

      {/* Seção Principal */}
      <div className="compra-main-content">
        {/* Seção de Texto */}
        <motion.section 
          className="compra-text-section-cp"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
        >
          <motion.div 
            className="text-content-cp"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1 }}
          >
            <div className="section-title-cp">
              <FaHistory className="section-icon" />
              Valorizamos seu instrumento 
            </div>
            
            <p className="classic-text">
              "Compramos pianos que necessitam de reforma para execução de toda manutenção e posterior revenda com todas garantias."
            </p>
            
            <div className="modern-text">
              <p>Entre em contato conosco, informe o bairro que o piano se encontra. Em caso de prédio, informar se cabe no elevador e andar.</p>
              <p>Envie fotos e informe sua oferta. Pagamento à vista e retirada por nossa conta.</p>
              <p>Também utilizamos seu piano usado como parte de pagamento na compra de algum dos nossos.</p>
            </div>
            
            <div className="benefits-grid">
              <div className="benefit-item">
                <FaMoneyBillWave className="benefit-icon" />
                <span>Pagamento à vista</span>
              </div>
              <div className="benefit-item">
                <FaTruck className="benefit-icon" />
                <span>Retirada gratuita</span>
              </div>
              <div className="benefit-item">
                <FaExchangeAlt className="benefit-icon" />
                <span>Permuta por outro piano</span>
              </div>
              <div className="benefit-item">
                <FaCamera className="benefit-icon" />
                <span>Avaliação por fotos</span>
              </div>
            </div>
          </motion.div>
        </motion.section>

        {/* Galeria de Pianos */}
        <motion.section 
          className="piano-gallery-section"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <h3 className="gallery-title">Pianos Adquiridos e Restaurados</h3>
          
          <motion.div 
            className="gallery-container"
            key={currentImageIndex}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            <div className={`piano-image vintage-${Math.floor(currentImage.year / 10) * 10}`}>
              <img 
                src={currentImage.src} 
                alt={currentImage.alt}
              />
              <div className="image-overlay">
                <span className="year-badge">{currentImage.year}</span>
                <span className="piano-description">{currentImage.alt}</span>
              </div>
            </div>
          </motion.div>
          
          <div className="gallery-dots">
            {galleryImages.map((_, index) => (
              <button
                key={index}
                className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                onClick={() => setCurrentImageIndex(index)}
              />
            ))}
          </div>
        </motion.section>
      </div>

      {/* Rodapé Elegante */}
      <motion.footer 
        className="compra-footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.2 }}
      >
        <p>Entre em contato para uma avaliação sem compromisso</p>
              <motion.a
                href="tel:1122565987"
                className="phone-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <FaPhone /> Fale Conosco
              </motion.a>
      </motion.footer>
    </div>
  );
};

export default CompraDePianos;